import React, { PropsWithChildren, useMemo } from 'react';
import useMetaStore from '@/store/useMetaStore';
import _ from 'lodash';

/** 权限校验 */
export function useAuth({ moduleCode, ability }: {
  /** 模型code */
  moduleCode?: string;
  /** 权限点 */
  ability?: string;
}) {
  const { auth } = useMetaStore();
  const isAuthorized = useMemo(() => {
    // 所有配置都存在时进行鉴权(至少有一个模块配置才认为有权限控制)
    if (auth && auth.length > 0 && moduleCode && ability) {
      const moduleAuth = auth.find((a) => a.key === moduleCode);
      if (moduleAuth) {
        return moduleAuth.abilitySet.includes(ability);
      }
      return false;
    }
    return true;
  }, [auth, moduleCode, ability]);

  return isAuthorized;
}
